export default {
  slug: "hub",
  code: "HB",
  label: "Hub",
  logoFamily: "jb",
};
